function GalleryImage(props){
    return <div className="gallery_image_wrapper">
        <img onClick={()=>props.setImageLightbox(props.src)} className="gallery_image" src={props.src}></img>
    </div>
}
export default GalleryImage;